<template>
  <div>
    <!-- 列表 -->
      <div style="overflow: auto;" >

          <div class="main-table">



    <vs-table :data="tableData" noDataText="暂无数据" >
      <template slot="thead">
        <vs-th v-for="(headData, index) in headData" :class="{quesCell: index > 14}" :key="index">
          {{ headData }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ indextr + 1 }}
          </vs-td>
            <vs-td>{{tr.userName}}</vs-td>
            <vs-td>{{tr.userCode}}</vs-td>
            <vs-td>{{tr.userType}}</vs-td>
            <vs-td>{{tr.status === 1?"是":"否"}}</vs-td>
            <vs-td>{{tr.createTime}}</vs-td>

<!--          <vs-td style="">-->
<!--            {{ tr.zone }}-->
<!--          </vs-td>-->
<!--          <vs-td>-->
<!--            {{ tr.storeId }}-->
<!--          </vs-td>-->
<!--          <vs-td style="">-->
<!--            {{ tr.storeName }}-->
<!--          </vs-td>-->
<!--          <vs-td style="">-->
<!--            {{ tr.contactPersoon }}-->
<!--          </vs-td>-->
<!--          <vs-td style="">-->
<!--            {{ tr.contactPhone }}-->
<!--          </vs-td>-->
<!--           <vs-td style="">-->
<!--            {{ tr.contactAddress }}-->
<!--          </vs-td>-->
<!--           <vs-td style="">-->
<!--            {{ tr.salesPerson }}-->
<!--          </vs-td>-->
<!--          &lt;!&ndash; <vs-td style="">-->
<!--            {{ tr.salesPhone }}-->
<!--          </vs-td> &ndash;&gt;-->
<!--           <vs-td style="">-->
<!--            {{ tr.belongCustomer }}-->
<!--          </vs-td>-->
<!--          <vs-td style="">-->
<!--            {{ tr.belongCustomerNo }}-->
<!--          </vs-td>-->

<!--           <vs-td style="">-->
<!--            {{ tr.higherCustomer }}-->
<!--          </vs-td>-->
<!--           <vs-td style="">-->
<!--            {{ tr.higherCustomerNo }}-->
<!--          </vs-td>-->

<!--           <vs-td style="">-->
<!--            {{ tr.firstClassCustomer }}-->
<!--          </vs-td>-->
<!--           <vs-td style="">-->
<!--            {{ tr.firstClassCustomerNo }}-->
<!--          </vs-td>-->
<!--           <vs-td style="width:190px">-->
<!--            {{ tr.storeAddress }}-->
<!--          </vs-td>-->
            <vs-td v-for="(item,index) in tr.appendData" :key="index" class="quesCell">
                <div v-if="item.type === 'image'">
                    <el-image v-for="(v,vIndex) in item.values" :src="v" style="width: 80px;height: 80px" :key="vIndex" :preview-src-list="item.values"></el-image>
                </div>
                <div v-else-if="item.type === 'file'">
                    <el-button v-for="(v,vIndex) in item.values" type="text"><a :href="v">{{decodeURI(v.split("=")[1])}}</a></el-button>
                </div>
                <div v-else>{{item.values.join(',')}}</div>
            </vs-td>
<!--          <vs-td v-for="(qData, qIdx) in tr.questions" :key="'q_idx_' + qIdx" class="quesCell">-->
<!--              <div v-if="!qData.answer">qData</div>-->
<!--              <div v-else-if="qData.answer.indexOf('http') === 0">-->
<!--                  <el-image-->
<!--                      v-for="(url,index) in qData.answer.split(',')"-->
<!--                      style="width: 80px; height: 80px"-->
<!--                      :src="url"-->
<!--                      :key="index"-->
<!--                      :preview-src-list="qData.answer.split(',')">-->
<!--                  </el-image>-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                  {{ qData.answer }}-->
<!--              </div>-->
<!--          </vs-td>-->
        </vs-tr>
      </template>
    </vs-table>


          </div>
      </div>

      <vx-card title="" class="mt-10">
          <div class="p-6" style="">

<!--              <vs-button type="filled" class="mr-6" color="primary" @click="bindWhIds">保存</vs-button>-->

              <vs-button type="border" color="danger" @click="cancel">返回</vs-button>

          </div>

      </vx-card>


  </div>
</template>

<script>
import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution.ts";
import constants from "../../../constants.ts";
import {Navigator} from "@/router/Navigator";
import {downloadExcel, downloadFileTemplate} from "@/utils/downloadExcel.js";

export default {
  data() {
    return {
      isAdd: false,
      params: { activityName: "", page: 0, size: 10, id: "" },
      options: [
        { label: "关闭", code: 1 },
        { label: "开启", code: 2 }
      ],
        headData:["序号","客户名称","客户编码","客户类型","是否确认","确认时间"],
      // headData: [
      //   "序号",
      //   "大区",
      //   "门店编号",
      //   "门店名称",
      //   "联系人",
      //   "联系电话",
      //   "联系地址",
      //   "销售经理",
      //   // "销售经理电话",
      //   "归属客户",
      //   "归属客户编号",
      //   "上级客户",
      //   "上级客户编号",
      //   "一级客户",
      //   "一级客户编号",
      //   "门店地址",
      //   // "问题列表"
      // ],
      tableData: []
    };
  },
  filters: {
    getStatus(val) {
      let text = "--";
      switch (val) {
        case 1:
          text = "关闭";
          break;
        case 2:
          text = "开启";
      }
      return text;
    },
    getType(val) {
      const item = constants.typeOptions.find(({ code }) => code === val) || {};
      return item.label;
    }
  },
  computed: {
      getTableHeads() {
          let ret = this.headData;
          if (this.tableData && this.tableData.length > 0) {
              let json = this.tableData[0].questions || [];
              let idx, extraHeads = [];
              for (idx = 0; idx < json.length; idx++) {
                  extraHeads.push("*" + json[idx].questionTitle);
              }
              ret = [
                  ...this.headData,
                  ...extraHeads
              ];
          }

          return ret;
      },
    detailId() {
      const id = this.$route.params.id;
      return id === "0" ? "" : id;
    }
  },
  mounted() {
      this.templateId =this.$route.params.templateId;
    this.getTableData();
  },
  methods: {
      // //下载文件模板
      // downloadTemplate(url) {
      //     let url = url;
      //     let name = '任务活动导入模板.xlsx';
      //     downloadFileTemplate(url, name);
      // },
    addData() {
      const path = `storeactivities/configure/0`;
      this.$router.push(path);
    },
    getTableData() {
      DistributionApi.queryTaskRecordInfo({
        data:{
            id: this.detailId,
            templateId:this.templateId,
        },
          size:10,
          current:1

      }).then(res=>{
          console.log(res);
          this.headData = this.headData.concat(res.result.header);
          this.tableData = res.result.records;
          console.log(this.headData);
      });
    },
    edit({ id = "" }) {
      const path = `storeactivities/configure/${id}`;
      this.$router.push({ path });
    },
    copy(row, index) {
      const oInput = this.$refs[`input${index}`][0];
      const range = document.createRange();
      range.selectNode(oInput);
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
    },
    saveDate(val) {
      this.params.date = val;
    },
      cancel() {
          let path = `/taskManage/storeactivities?tab=2`;
          Navigator.redirect(path);
      },

  }
};
</script>

<style scoped>
.line {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.item {
  margin-right: 10px;
  width: 200px;
}
.none {
  opacity: 0;
}

.vs-table--content {

}
.main-table {

    /*min-width: 2800px;*/

    .vs-table--content {

        .vs-table--tbody-table .tr-values {

        }
    }
    .quesCell {
        /*background-color: red;*/
        color: red;
    }

    th {
        min-width: 80px;
    }
    td {
        white-space: nowrap;
    }

}
</style>
